import { Component, Input, OnInit } from '@angular/core';
import { DisplayHelperService } from '../shared/display-helper.service';

@Component({
    selector: 'page-performance-audit-display-binary',
    standalone: false,
    template: `
<div class="page-performance-audit-display">
    <mon-markdown-viewer [monMarkdown]="audit.description"></mon-markdown-viewer>

    <table *ngIf="showTable"
           class="table table-hover table-fixed">
        <thead>
        <tr>
            <th [class]="heading.cssClass" *ngFor="let heading of headings; trackBy: trackByIndex">{{heading.text}}</th>
        </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td class="text-ellipsis"
                    [class]="column.cssClass"
                    *ngFor="let column of item.columns; trackBy: trackByIndex"
                    [innerHTML]="column.text">
                </td>
            </tr>
        </tbody>
    </table>
</div>
`,
})
export class PagePerformanceAuditDisplayBinaryComponent implements OnInit {
    @Input() audit: any;

    showTable: boolean = false;
    headings: any[] = [];
    items: any[] = [];

    constructor (private displayHelperService: DisplayHelperService) {}

    ngOnInit (): void {
        this.showTable = this.displayHelperService.hasDetails(this.audit.details) &&
            this.displayHelperService.isDetailTypeTable(this.audit.details.type) &&
            this.displayHelperService.hasDetailsTypeContent(this.audit.details);

        if (this.showTable) {
            this.headings = this.displayHelperService.getHeadings(this.audit.details);
            this.items = this.displayHelperService.getItems(this.audit.details);
        }
    }

    trackByIndex (index: number): number {
        return index;
    }
}
